/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeEvent, FC, InputHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import { GREEN, GREY_LIGHTEST, GREY_MEDIUM, RED, WHITE } from '../../utils/colors'
import { SM } from '../../utils/screenSizes'

export const Outside = styled.div`
  .info, .error {
    margin-top: -5px;
    margin-bottom: 17px;
    margin-left: 20px;
    font-size: 10px;
    line-height: 12px;
    display: block;
    a {
      color: inherit;
    }
  }

  .error {
    color: ${RED};
    margin-top: -10px;
  }
`

type ContainerProps = {
  $error?: boolean
}

type InputProps = {
  type?: 'text' | 'password' | 'email' | 'tel' | 'textarea'
  placeholder?: string
  onChange?: {
    (e: ChangeEvent<any>): void;
    <T_1 = string | ChangeEvent<any>>(field: T_1): T_1 extends ChangeEvent<any> ? void : (e: string | ChangeEvent<any>) => void;
  };
}

type InputAndContainerProps = InputHTMLAttributes<HTMLInputElement> & InputProps & ContainerProps;

export const Container = styled.div<ContainerProps>`
  min-height: 60px;
  background: ${WHITE};
  border: 1px solid ${props => props.$error ? RED : GREY_LIGHTEST};
  box-sizing: border-box;
  font-family: 'Segoe UI', sans-serif;
  border-radius: 3px;
  position: relative;
  margin-bottom: 17px;
  line-height: initial;

  label {
    position: absolute;
    top: 22px;
    left: 22px;
    font-size: 18px;
    color: ${props => props.$error ? RED : GREY_MEDIUM};
    pointer-events: none;
    transition: linear all 0.1s;

    @media (max-width: ${SM}) {
      font-size: 14px;
    }
  }

  label.focus {
    top: 12px;
    font-size: 10px;
  }

  .select & {
    label {
      top: 17px;
    }

    label.focus {
      top: 12px;
    }
  }

  .right_attachment {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }
`

const Input: FC<InputAndContainerProps> = ({ type, ...restProps }) => {
  if (type === 'textarea') {
    const handleOnChange = restProps.onChange
    return (
      <textarea
        className={restProps.className}
        onChange={handleOnChange}
        value={restProps.value}
        placeholder={restProps.placeholder}
      />
    )
  }

  return <input type={type} {...restProps} />
}

export const InputElement = styled(Input)`
  width: 100%;
  height: 100%;
  border: none;
  color: ${props => props.$error ? RED : GREEN};
  font-size: 18px;
  line-height: 24px;
  min-height: 60px;
  outline: none;
  padding: 17px 22px;
  padding-top: 24px;
  border-radius: 3px;
  background: transparent;
  font-family: 'Segoe UI', sans-serif;

  ${props => props.type === 'textarea' && css`
    resize: none;
    padding-top: 0px;
    margin-bottom: 17px;
    margin-top: 32px;
    line-height: 20px;
  `}

  &:focus ~ label,
  ${props => props.type === 'textarea'
    ? '&:not(:empty) ~ label'
    : '&:not([value=""]) ~ label'
}
  {
    top: 12px;
    font-size: 10px;
  }
`
